// src/app/authMiddleware.js
const authMiddleware = (store) => (next) => (action) => {
  // check if API returned Unauthenticated (based on payload or error)
  if (action.payload && (action.payload?.data?.httpStatus === 401 || action.payload.status === 401 || action.payload.message === "Unauthenticated" || action.payload.message === "Authentication token is missing or invalid")) {
    // clear localStorage
    localStorage.removeItem("user");
    // reload the app
    window.location.reload();
  }

  return next(action);
};

export default authMiddleware;
